export default function mottaEquipe() {
    const lista = document.querySelectorAll('.button-equipe-mobile');

    lista.forEach(i => {
        i.addEventListener('click', (e) => {
            const pai = e.target.closest('.list-socios')
            pai.classList.add('mostrar-todos')
        })
    })
}